import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLines({ lines, className = "", lineClassName = "", baseDelay = 0.15 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-1">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: baseDelay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Chapter({ num, label, dark = false }) {
  return (
    <Reveal className="mb-10">
      <div className="flex items-center gap-4">
        <span className={`font-mono text-xs tracking-[0.3em] ${dark ? "text-gold" : "text-gold"}`}>{num}</span>
        <span className="gold-hairline w-16" />
        <span className={`eyebrow ${dark ? "text-gold" : ""}`}>{label}</span>
      </div>
    </Reveal>
  );
}
